module.exports = __webpack_public_path__ + "static/redcap-775b16df8df9d6993b661a3d515b8cab.jpeg";